import { createContext, useContext, useEffect, useState } from "react";
import { authApi } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("dochub_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("dochub_token");
    if (!token) { setLoading(false); return; }
    authApi.me()
      .then((u) => { setUser(u); localStorage.setItem("dochub_user", JSON.stringify(u)); })
      .catch(() => { setUser(null); localStorage.clear(); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await authApi.login(email, password);
    localStorage.setItem("dochub_token", res.token);
    localStorage.setItem("dochub_user", JSON.stringify(res.user));
    setUser(res.user);
    return res.user;
  };

  const logout = () => {
    localStorage.removeItem("dochub_token");
    localStorage.removeItem("dochub_user");
    setUser(null);
  };

  const setSessionFromToken = (token, u) => {
    localStorage.setItem("dochub_token", token);
    localStorage.setItem("dochub_user", JSON.stringify(u));
    setUser(u);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, setSessionFromToken }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export const isMaster = (u) => u?.role === "master_admin";
export const isBizAdmin = (u) => u?.role === "business_admin";
export const isAccounting = (u) => u?.role === "accounting_user";
export const isBranchUser = (u) => u?.role === "branch_user";
export const canPublish = (u) => u?.role === "master_admin" || u?.role === "accounting_user";
export const canManageSettings = (u) => u?.role === "master_admin" || u?.role === "business_admin";

export const userBusinessIds = (u) => u?.business_ids || (u?.business_id ? [u.business_id] : []);
export const userBranchIds = (u) => u?.branch_ids || (u?.branch_id ? [u.branch_id] : []);

export const ROLE_LABELS = {
  master_admin: "Master Admin",
  business_admin: "Business Admin",
  accounting_user: "Accounting User",
  branch_user: "Branch User",
};
